var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53125 0.0108643C8.0091 0.0108643 7.50835 0.218286 7.13913 0.587498C6.76992 0.95671 6.5625 1.45747 6.5625 1.97961V2.63586H1.96875C1.44661 2.63586 0.945846 2.84329 0.576634 3.2125C0.207421 3.58171 0 4.08247 0 4.60461L0 6.42111L9.99337 9.08549C10.3253 9.17389 10.6747 9.17389 11.0066 9.08549L21 6.42111V4.60461C21 4.08247 20.7926 3.58171 20.4234 3.2125C20.0542 2.84329 19.5534 2.63586 19.0312 2.63586H14.4375V1.97961C14.4375 1.45747 14.2301 0.95671 13.8609 0.587498C13.4917 0.218286 12.9909 0.0108643 12.4688 0.0108643H8.53125ZM8.53125 1.32336H12.4688C12.6428 1.32336 12.8097 1.3925 12.9328 1.51558C13.0559 1.63865 13.125 1.80557 13.125 1.97961V2.63586H7.875V1.97961C7.875 1.80557 7.94414 1.63865 8.06721 1.51558C8.19028 1.3925 8.3572 1.32336 8.53125 1.32336Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.1046C0 15.6267 0.207421 16.1275 0.576634 16.4967C0.945846 16.8659 1.44661 17.0733 1.96875 17.0733H19.0312C19.5534 17.0733 20.0542 16.8659 20.4234 16.4967C20.7926 16.1275 21 15.6267 21 15.1046V7.68896L10.6693 10.4413C10.5584 10.4709 10.4416 10.4709 10.3307 10.4413L0 7.68896V15.1046Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeker);
export default __webpack_public_path__ + "static/media/seeker.31e70ecdc80b4de101b47bba654530b3.svg";
export { ForwardRef as ReactComponent };